// Avena adv2 runtime: reading progress + bundle radio form -> cart/add.js -> theme slide cart (cart-drawer.renderContents),
// whose Checkout button is handled by the layout's Sticky.io hand-off script. No /cart redirect (round 8).
(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    const cfg = { adding: root.dataset.adding, added: root.dataset.added, error: root.dataset.error, unavailable: root.dataset.unavailable };
    const fill = root.querySelector('.reading-progress-fill');
    const progress = () => {
      if (!fill) return;
      const range = root.scrollHeight - innerHeight;
      fill.style.width = Math.max(0, Math.min(100, range > 0 ? (scrollY - root.offsetTop) / range * 100 : 0)) + '%';
    };
    addEventListener('scroll', progress, { passive: true });
    progress();
    const form = root.querySelector('.acu-form');
    if (!form) return;
    const button = form.querySelector('.acm-submit'), status = form.querySelector('.acm-status'), fallback = form.querySelector('.acm-fallback');
    const label = button.querySelector('span'), original = label.textContent;
    let pending = false;
    const selected = () => form.querySelector('[name=id]:checked:not(:disabled)');
    const update = () => { button.disabled = pending || !selected(); };
    form.addEventListener('change', update);
    update();
    const drawer = () => document.querySelector('cart-drawer');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (pending) return;
      if (!selected()) { status.hidden = false; status.textContent = cfg.unavailable; return; }
      const id = Number(selected().value);
      if (!Number.isSafeInteger(id)) return;
      pending = true; update(); label.textContent = cfg.adding; status.hidden = true; fallback.hidden = true; button.setAttribute('aria-busy', 'true');
      try {
        const d = drawer();
        const body = { items: [{ id, quantity: 1 }] };
        if (d && typeof d.getSectionsToRender === 'function') {
          body.sections = d.getSectionsToRender().map((s) => s.id).join(',');
          body.sections_url = location.pathname;
        }
        const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok || data.status >= 400) throw new Error(data.description || cfg.error);
        if (d && typeof d.renderContents === 'function' && data.sections) {
          d.renderContents(data);           // theme method: swaps drawer markup and opens it
        } else if (d && typeof d.open === 'function') {
          d.open();
        } else {
          location.assign((window.routes && window.routes.cart_url) || '/cart');   // no drawer on this layout: last resort
        }
        status.hidden = true;
      } catch (error) {
        status.hidden = false; status.textContent = error.message || cfg.error; fallback.hidden = false;
      } finally {
        pending = false; label.textContent = original; button.removeAttribute('aria-busy'); update();
      }
    });
  }
  document.querySelectorAll('.qp').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.qp').forEach(init));
})();
